// ======================================================================
// File Name       : adaptive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { MIN_DATE, MAX_DATE, parseDateForDetail } from '../utils/index';
import * as ActionTypes from '../constants/actionTypes/adaptive';

const initialState = {
  recordNum: 0,
  importResultList: [],
};

export default function adaptive(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.DISCRIMINATION_DEGREE_DATA: {
      const { courseList } = action;
      let courseListData = {};
      if (courseList && courseList.courseList && courseList.courseList.length) {
        courseListData = courseList.courseList.reduce((acc, cur) => {
          if (cur && cur.courseSecernId) {
            acc.bySecernId[cur.courseSecernId] = cur;
            acc.allSecernIds.push(cur.courseSecernId);
          }
          return acc;
        }, {
          bySecernId: {},
          allSecernIds: [],
        });
      }
      return {
        ...state,
        courseListData,
      };
    }
    case ActionTypes.RECEIVED_ADAPTIVE_META_IMPORT_LIST: {
      const { recordNum, importResultList } = action;
      return {
        ...state,
        recordNum,
        importResultList,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
